import { useState, useMemo, useEffect, useCallback } from 'react';
import PageHeader from '../../components/ui/PageHeader';
import Modal from '../../components/ui/Modal';
import toast from 'react-hot-toast';
import api from '../../services/api';

const moeda = v => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const fmtData = d => d ? new Date(d + (d.includes('T') ? '' : 'T00:00:00')).toLocaleDateString('pt-BR') : '—';
const fmtDH   = d => d ? new Date(d).toLocaleString('pt-BR', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' }) : '—';

const Ico = ({ d, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    {(Array.isArray(d) ? d : [d]).map((p, i) => <path key={i} d={p} />)}
  </svg>
);

const ETAPAS = [
  { id: 'prospeccao',   label: 'Prospecção',   cor: '#94A3B8', bg: 'rgba(148,163,184,.12)' },
  { id: 'qualificacao', label: 'Qualificação',  cor: '#38BDF8', bg: 'rgba(56,189,248,.12)'  },
  { id: 'proposta',     label: 'Proposta',      cor: '#A78BFA', bg: 'rgba(167,139,250,.12)' },
  { id: 'negociacao',   label: 'Negociação',    cor: '#FBBF24', bg: 'rgba(251,191,36,.12)'  },
];

const ORIGEM_LABEL = {
  indicacao: 'Indicação', inbound: 'Inbound', outbound: 'Outbound',
  evento: 'Evento', redes_sociais: 'Redes Sociais', outro: 'Outro',
};

const TIPO_INTERACAO = [
  { v: 'ligacao', l: '📞 Ligação' }, { v: 'email', l: '📧 E-mail' },
  { v: 'reuniao', l: '🤝 Reunião' }, { v: 'proposta', l: '📄 Proposta' },
  { v: 'whatsapp', l: '💬 WhatsApp' }, { v: 'outro', l: 'Outro' },
];

// ── FORM LEAD ─────────────────────────────────────────────────────────────────

function FormLead({ inicial, usuarios, onSalvar, onFechar }) {
  const [f, setF] = useState(inicial || {
    empresa: '', contato_nome: '', contato_email: '', contato_telefone: '',
    contato_cargo: '', porte: '', segmento: '', origem: 'inbound',
    valor_estimado: '', probabilidade: 50, previsao_fechamento: '',
    responsavel_id: '', observacoes: '',
  });
  const s = (k, v) => setF(p => ({ ...p, [k]: v }));
  return (
    <form onSubmit={e => { e.preventDefault(); onSalvar(f); }} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="col-span-2">
          <label className="form-label">Empresa *</label>
          <input className="form-input" value={f.empresa} onChange={e => s('empresa', e.target.value)} required placeholder="Nome da empresa" />
        </div>
        <div><label className="form-label">Contato</label><input className="form-input" value={f.contato_nome} onChange={e => s('contato_nome', e.target.value)} placeholder="Nome do contato" /></div>
        <div><label className="form-label">Cargo</label><input className="form-input" value={f.contato_cargo} onChange={e => s('contato_cargo', e.target.value)} placeholder="Ex: CEO, Gerente de Mkt" /></div>
        <div><label className="form-label">E-mail</label><input type="email" className="form-input" value={f.contato_email} onChange={e => s('contato_email', e.target.value)} /></div>
        <div><label className="form-label">WhatsApp / Telefone</label><input className="form-input" value={f.contato_telefone} onChange={e => s('contato_telefone', e.target.value)} /></div>
        <div>
          <label className="form-label">Segmento</label>
          <input className="form-input" value={f.segmento} onChange={e => s('segmento', e.target.value)} placeholder="Ex: Varejo, Saúde, SaaS..." />
        </div>
        <div>
          <label className="form-label">Porte</label>
          <select className="form-input" value={f.porte} onChange={e => s('porte', e.target.value)}>
            <option value="">Selecione...</option>
            <option value="micro">Micro (1–9)</option>
            <option value="pequena">Pequena (10–49)</option>
            <option value="media">Média (50–249)</option>
            <option value="grande">Grande (250+)</option>
          </select>
        </div>
        <div>
          <label className="form-label">Origem</label>
          <select className="form-input" value={f.origem} onChange={e => s('origem', e.target.value)}>
            {Object.entries(ORIGEM_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </div>
        <div>
          <label className="form-label">Responsável</label>
          <select className="form-input" value={f.responsavel_id} onChange={e => s('responsavel_id', e.target.value)}>
            <option value="">Sem responsável</option>
            {usuarios.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
          </select>
        </div>
        <div><label className="form-label">Valor estimado (R$)</label><input type="number" className="form-input" value={f.valor_estimado} onChange={e => s('valor_estimado', e.target.value)} placeholder="0,00" /></div>
        <div>
          <label className="form-label">Probabilidade: <strong style={{ color: '#E2E8F4' }}>{f.probabilidade}%</strong></label>
          <input type="range" min="0" max="100" step="5" value={f.probabilidade} onChange={e => s('probabilidade', Number(e.target.value))} style={{ width: '100%', accentColor: '#6C4CF5', marginTop: 6 }} />
        </div>
        <div><label className="form-label">Previsão de fechamento</label><input type="date" className="form-input" value={f.previsao_fechamento || ''} onChange={e => s('previsao_fechamento', e.target.value)} /></div>
        <div className="col-span-2">
          <label className="form-label">Observações</label>
          <textarea className="form-input" rows={2} value={f.observacoes || ''} onChange={e => s('observacoes', e.target.value)} placeholder="Contexto, necessidades, dores..." />
        </div>
      </div>
      <div className="flex gap-2 pt-2 border-t border-gray-100">
        <button type="submit" className="btn-primary flex-1">{inicial ? 'Salvar' : 'Criar Lead'}</button>
        <button type="button" onClick={onFechar} className="btn-secondary">Cancelar</button>
      </div>
    </form>
  );
}

// ── DETALHE DO LEAD ───────────────────────────────────────────────────────────

function DetalheLead({ lead, usuarios, onMover, onEditar, onExcluir, onFechar }) {
  const [interacoes, setInteracoes] = useState([]);
  const [loadingInt, setLoadingInt] = useState(true);
  const [formInt, setFormInt] = useState({ tipo: 'ligacao', descricao: '', proximo_contato: '' });
  const [enviandoInt, setEnviandoInt] = useState(false);
  const [modalPerda, setModalPerda] = useState(false);
  const [motivoPerda, setMotivoPerda] = useState('');

  useEffect(() => {
    api.get(`/crm/leads/${lead.id}/interacoes`)
      .then(r => setInteracoes(r.data || []))
      .finally(() => setLoadingInt(false));
  }, [lead.id]);

  const addInteracao = async e => {
    e.preventDefault();
    if (!formInt.descricao.trim()) return;
    setEnviandoInt(true);
    try {
      const { data } = await api.post(`/crm/leads/${lead.id}/interacoes`, formInt);
      setInteracoes(prev => [data, ...prev]);
      setFormInt({ tipo: 'ligacao', descricao: '', proximo_contato: '' });
      toast.success('Interação registrada!');
    } catch { toast.error('Erro ao registrar interação.'); }
    finally { setEnviandoInt(false); }
  };

  const mover = async (etapa) => {
    if (etapa === 'perdido') { setModalPerda(true); return; }
    await onMover(lead.id, etapa, '');
    onFechar();
  };

  const confirmarPerda = async () => {
    await onMover(lead.id, 'perdido', motivoPerda);
    setModalPerda(false);
    onFechar();
  };

  const resp = usuarios.find(u => u.id === lead.responsavel_id);
  const diasFechamento = lead.previsao_fechamento ? Math.ceil((new Date(lead.previsao_fechamento) - new Date()) / 86400000) : null;

  return (
    <div className="space-y-5">
      {/* Cabeçalho com valores */}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {lead.valor_estimado && (
          <div style={{ padding: '8px 14px', background: 'rgba(108,76,245,.12)', borderRadius: 10, border: '1px solid rgba(108,76,245,.25)' }}>
            <p style={{ fontSize: 10, color: '#A78BFA', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Valor</p>
            <p style={{ fontSize: 18, fontWeight: 700, color: '#E2E8F4' }}>{moeda(lead.valor_estimado)}</p>
          </div>
        )}
        <div style={{ padding: '8px 14px', background: 'rgba(255,255,255,.04)', borderRadius: 10, border: '1px solid #2A3652' }}>
          <p style={{ fontSize: 10, color: '#64748B', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Probabilidade</p>
          <p style={{ fontSize: 18, fontWeight: 700, color: lead.probabilidade >= 70 ? '#4ADE80' : lead.probabilidade >= 40 ? '#FBBF24' : '#F87171' }}>{lead.probabilidade}%</p>
        </div>
        {lead.previsao_fechamento && (
          <div style={{ padding: '8px 14px', background: 'rgba(255,255,255,.04)', borderRadius: 10, border: '1px solid #2A3652' }}>
            <p style={{ fontSize: 10, color: '#64748B', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Fechamento</p>
            <p style={{ fontSize: 14, fontWeight: 600, color: diasFechamento !== null && diasFechamento < 7 ? '#FBBF24' : '#E2E8F4' }}>
              {fmtData(lead.previsao_fechamento)}
              {diasFechamento !== null && <span style={{ fontSize: 11, color: '#64748B', marginLeft: 6 }}>({diasFechamento >= 0 ? `${diasFechamento}d` : `${Math.abs(diasFechamento)}d atraso`})</span>}
            </p>
          </div>
        )}
      </div>

      {/* Dados do contato */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px 16px', fontSize: 13 }}>
        {[
          ['Contato', lead.contato_nome],
          ['Cargo', lead.contato_cargo],
          ['E-mail', lead.contato_email],
          ['Telefone', lead.contato_telefone],
          ['Segmento', lead.segmento],
          ['Porte', lead.porte],
          ['Origem', ORIGEM_LABEL[lead.origem] || lead.origem],
          ['Responsável', resp?.nome],
        ].map(([k, v]) => v ? (
          <div key={k}><span style={{ color: '#64748B' }}>{k}:</span> <span style={{ color: '#CBD5E1' }}>{v}</span></div>
        ) : null)}
      </div>

      {lead.observacoes && (
        <div style={{ padding: '10px 14px', background: 'rgba(255,255,255,.03)', borderRadius: 10, border: '1px solid #2A3652', fontSize: 13, color: '#94A3B8', lineHeight: 1.6 }}>
          {lead.observacoes}
        </div>
      )}

      {/* Mover etapa */}
      <div>
        <p style={{ fontSize: 11, fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8 }}>Mover para</p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {[...ETAPAS, { id: 'ganho', label: 'Ganho ✓', cor: '#4ADE80', bg: 'rgba(74,222,128,.12)' }, { id: 'perdido', label: 'Perdido ✗', cor: '#F87171', bg: 'rgba(248,113,113,.12)' }]
            .filter(e => e.id !== lead.etapa)
            .map(e => (
              <button key={e.id} onClick={() => mover(e.id)} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 999, border: `1px solid ${e.cor}40`, color: e.cor, background: e.bg, cursor: 'pointer', fontWeight: 600 }}>
                {e.label}
              </button>
            ))}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={onEditar} style={{ fontSize: 12, color: '#6C4CF5', background: 'rgba(108,76,245,.1)', border: 'none', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontWeight: 600 }}>Editar Lead</button>
        <button onClick={onExcluir} style={{ fontSize: 12, color: '#F87171', background: 'rgba(248,113,113,.1)', border: 'none', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontWeight: 600 }}>Excluir</button>
      </div>

      {/* Interações */}
      <div>
        <p style={{ fontSize: 11, fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 10 }}>Histórico de interações</p>
        <div style={{ maxHeight: 200, overflowY: 'auto', marginBottom: 14 }}>
          {loadingInt ? <p style={{ fontSize: 13, color: '#64748B' }}>Carregando...</p> : interacoes.length === 0
            ? <p style={{ fontSize: 13, color: '#64748B' }}>Nenhuma interação registrada.</p>
            : interacoes.map(i => (
              <div key={i.id} style={{ padding: '10px 12px', marginBottom: 8, background: 'rgba(255,255,255,.03)', border: '1px solid #2A3652', borderRadius: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
                  <span style={{ fontSize: 11, fontWeight: 700, color: '#A78BFA', background: 'rgba(167,139,250,.12)', padding: '2px 8px', borderRadius: 6 }}>{TIPO_INTERACAO.find(t => t.v === i.tipo)?.l || i.tipo}</span>
                  <span style={{ fontSize: 11, color: '#64748B' }}>{fmtDH(i.criado_em)}</span>
                  {i.autor && <span style={{ fontSize: 11, color: '#64748B', marginLeft: 'auto' }}>{i.autor.split(' ')[0]}</span>}
                </div>
                <p style={{ fontSize: 13, color: '#CBD5E1', lineHeight: 1.5 }}>{i.descricao}</p>
                {i.proximo_contato && <p style={{ fontSize: 11, color: '#FBBF24', marginTop: 4 }}>📅 Próximo contato: {fmtDH(i.proximo_contato)}</p>}
              </div>
            ))
          }
        </div>
        <form onSubmit={addInteracao} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div>
              <label className="form-label">Tipo</label>
              <select className="form-input" value={formInt.tipo} onChange={e => setFormInt(p => ({ ...p, tipo: e.target.value }))}>
                {TIPO_INTERACAO.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
              </select>
            </div>
            <div>
              <label className="form-label">Próximo contato</label>
              <input type="datetime-local" className="form-input" value={formInt.proximo_contato} onChange={e => setFormInt(p => ({ ...p, proximo_contato: e.target.value }))} />
            </div>
          </div>
          <div>
            <label className="form-label">Descrição *</label>
            <textarea className="form-input" rows={2} value={formInt.descricao} onChange={e => setFormInt(p => ({ ...p, descricao: e.target.value }))} required placeholder="O que foi discutido / próximos passos..." />
          </div>
          <button type="submit" disabled={enviandoInt} className="btn-primary">{enviandoInt ? 'Registrando...' : 'Registrar interação'}</button>
        </form>
      </div>

      {/* Modal motivo perda */}
      <Modal open={modalPerda} onClose={() => setModalPerda(false)} title="Motivo da perda" size="sm">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <textarea className="form-input" rows={3} value={motivoPerda} onChange={e => setMotivoPerda(e.target.value)} placeholder="Por que o lead foi perdido? (opcional)" />
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={confirmarPerda} style={{ flex: 1, padding: '9px 0', background: 'rgba(248,113,113,.15)', border: '1px solid rgba(248,113,113,.4)', borderRadius: 8, color: '#F87171', fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>Confirmar perda</button>
            <button onClick={() => setModalPerda(false)} className="btn-secondary">Cancelar</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

// ── COMPONENTE PRINCIPAL ──────────────────────────────────────────────────────

export default function CRM() {
  const [pipeline, setPipeline] = useState({ prospeccao: [], qualificacao: [], proposta: [], negociacao: [] });
  const [ganhos, setGanhos] = useState([]);
  const [perdidos, setPerdidos] = useState([]);
  const [metricas, setMetricas] = useState({ em_andamento: 0, ganhos: 0, perdidos: 0, ticket_medio: 0, projecao_receita: 0 });
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);

  const [modalNovo, setModalNovo] = useState(false);
  const [detalhe, setDetalhe]   = useState(null);
  const [editando, setEditando] = useState(null);
  const [filtroResp, setFiltroResp] = useState('');
  const [dragging, setDragging]  = useState(null);
  const [dragOver, setDragOver]  = useState(null);

  const carregar = useCallback(async () => {
    try {
      const [pip, met, leadsGanhos, leadsPerdidos] = await Promise.all([
        api.get('/crm/pipeline'),
        api.get('/crm/metricas'),
        api.get('/crm/leads', { params: { etapa: 'ganho' } }),
        api.get('/crm/leads', { params: { etapa: 'perdido' } }),
      ]);
      setPipeline(pip.data.pipeline || {});
      setMetricas(met.data || {});
      setGanhos(leadsGanhos.data || []);
      setPerdidos(leadsPerdidos.data || []);
    } catch { toast.error('Erro ao carregar CRM.'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    carregar();
    api.get('/usuarios/equipe').then(r => setUsuarios(r.data || [])).catch(() => {});
  }, [carregar]);

  const criarLead = async dados => {
    try { await api.post('/crm/leads', dados); toast.success('Lead criado!'); setModalNovo(false); carregar(); }
    catch (err) { toast.error(err.response?.data?.error || 'Erro.'); }
  };

  const editarLead = async dados => {
    try { await api.patch(`/crm/leads/${editando.id}`, dados); toast.success('Lead atualizado!'); setEditando(null); setDetalhe(null); carregar(); }
    catch (err) { toast.error(err.response?.data?.error || 'Erro.'); }
  };

  const moverLead = async (id, etapa, motivo_perda) => {
    try {
      await api.patch(`/crm/leads/${id}/etapa`, { etapa, motivo_perda });
      toast.success(etapa === 'ganho' ? '🎉 Lead ganho!' : etapa === 'perdido' ? 'Lead marcado como perdido.' : 'Lead movido!');
      carregar();
    } catch { toast.error('Erro ao mover lead.'); }
  };

  const excluirLead = async (id) => {
    if (!window.confirm('Excluir este lead?')) return;
    try { await api.delete(`/crm/leads/${id}`); toast.success('Lead excluído.'); setDetalhe(null); carregar(); }
    catch { toast.error('Erro ao excluir.'); }
  };

  const onDrop = async (etapa) => {
    if (!dragging || dragging.etapa === etapa) { setDragging(null); setDragOver(null); return; }
    await moverLead(dragging.id, etapa, '');
    setDragging(null); setDragOver(null);
  };

  const pipFiltrado = useMemo(() => {
    if (!filtroResp) return pipeline;
    const out = {};
    for (const [k, v] of Object.entries(pipeline)) out[k] = v.filter(l => l.responsavel_id === filtroResp);
    return out;
  }, [pipeline, filtroResp]);

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}><p style={{ color: '#64748B' }}>Carregando...</p></div>;

  return (
    <div>
      <PageHeader
        title="Acompanhamento Comercial"
        subtitle="Pipeline de leads e prospecções da agência"
        actions={<button onClick={() => setModalNovo(true)} className="btn-primary">+ Novo Lead</button>}
      />

      {/* Métricas */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" style={{ marginBottom: 24 }}>
        {[
          { label: 'Em andamento', valor: metricas.em_andamento, accent: '#38BDF8', icon: <Ico d={['M22 12h-4l-3 9L9 3l-3 9H2']} size={18} /> },
          { label: 'Ganhos', valor: metricas.ganhos, accent: '#4ADE80', icon: <Ico d="M20 6 9 17l-5-5" size={18} /> },
          { label: 'Perdidos', valor: metricas.perdidos, accent: '#F87171', icon: <Ico d={['M18 6 6 18','M6 6l12 12']} size={18} /> },
          { label: 'Projeção (prob.)', valor: moeda(metricas.projecao_receita), accent: '#A78BFA', icon: <Ico d={['M12 1v22','M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6']} size={18} /> },
        ].map(m => (
          <div key={m.label} style={{ background: '#19243A', border: '1px solid #2A3652', borderRadius: 14, padding: '16px 18px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
              <p style={{ fontSize: 10, fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{m.label}</p>
              <span style={{ color: m.accent, opacity: .85 }}>{m.icon}</span>
            </div>
            <p style={{ fontSize: 26, fontWeight: 700, color: '#E2E8F4', lineHeight: 1 }}>{m.valor}</p>
          </div>
        ))}
      </div>

      {/* Filtro */}
      {usuarios.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <select className="form-input" style={{ width: 'auto' }} value={filtroResp} onChange={e => setFiltroResp(e.target.value)}>
            <option value="">Todos os responsáveis</option>
            {usuarios.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
          </select>
        </div>
      )}

      {/* Kanban */}
      <div style={{ display: 'flex', gap: 14, overflowX: 'auto', paddingBottom: 16 }}>
        {ETAPAS.map(etapa => {
          const leads = pipFiltrado[etapa.id] || [];
          const valorTotal = leads.reduce((s, l) => s + Number(l.valor_estimado || 0), 0);
          return (
            <div key={etapa.id}
              className="crm-col"
              onDragOver={e => { e.preventDefault(); setDragOver(etapa.id); }}
              onDragLeave={() => setDragOver(null)}
              onDrop={() => onDrop(etapa.id)}
              style={{
                minWidth: 240, maxWidth: 260, flex: '0 0 250px',
                background: dragOver === etapa.id ? etapa.bg : 'rgba(25,36,58,.6)',
                border: `1px solid ${dragOver === etapa.id ? etapa.cor + '50' : '#2A3652'}`,
                borderTop: `3px solid ${etapa.cor}`,
                borderRadius: 14, padding: 14, transition: 'all .15s',
              }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div>
                  <p style={{ fontSize: 12, fontWeight: 700, color: etapa.cor, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{etapa.label}</p>
                  {valorTotal > 0 && <p style={{ fontSize: 10, color: '#64748B', marginTop: 2 }}>{moeda(valorTotal)}</p>}
                </div>
                <span style={{ fontSize: 11, fontWeight: 700, color: '#64748B', background: 'rgba(255,255,255,.07)', padding: '2px 8px', borderRadius: 999 }}>{leads.length}</span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {leads.map(lead => {
                  const dias = lead.previsao_fechamento ? Math.ceil((new Date(lead.previsao_fechamento) - new Date()) / 86400000) : null;
                  return (
                    <div key={lead.id}
                      draggable
                      onDragStart={() => setDragging(lead)}
                      onDragEnd={() => { setDragging(null); setDragOver(null); }}
                      onClick={() => setDetalhe(lead)}
                      style={{
                        background: '#19243A', border: `1px solid ${dias !== null && dias < 3 ? 'rgba(251,191,36,.3)' : '#2A3652'}`,
                        borderRadius: 10, padding: '10px 12px', cursor: 'pointer', transition: 'all .15s',
                        opacity: dragging?.id === lead.id ? 0.5 : 1,
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = '#1F2B45'}
                      onMouseLeave={e => e.currentTarget.style.background = '#19243A'}>
                      <p style={{ fontSize: 13, fontWeight: 600, color: '#E2E8F4', marginBottom: 3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{lead.empresa}</p>
                      {lead.contato_nome && <p style={{ fontSize: 11, color: '#64748B', marginBottom: 6 }}>{lead.contato_nome}{lead.contato_cargo ? ` · ${lead.contato_cargo}` : ''}</p>}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {lead.valor_estimado ? <span style={{ fontSize: 12, fontWeight: 700, color: '#A78BFA' }}>{moeda(lead.valor_estimado)}</span> : <span />}
                        <span style={{ fontSize: 11, color: lead.probabilidade >= 70 ? '#4ADE80' : lead.probabilidade >= 40 ? '#FBBF24' : '#F87171', fontWeight: 600 }}>{lead.probabilidade}%</span>
                      </div>
                      {lead.responsavel_nome && <p style={{ fontSize: 10, color: '#64748B', marginTop: 4 }}>{lead.responsavel_nome.split(' ')[0]}</p>}
                      {dias !== null && dias < 7 && <p style={{ fontSize: 10, color: dias < 0 ? '#F87171' : '#FBBF24', marginTop: 3, fontWeight: 600 }}>📅 {dias < 0 ? `${Math.abs(dias)}d atraso` : dias === 0 ? 'Fecha hoje!' : `Fecha em ${dias}d`}</p>}
                    </div>
                  );
                })}
              </div>

              {leads.length === 0 && (
                <div style={{ border: '2px dashed #2A3652', borderRadius: 10, padding: '16px 12px', textAlign: 'center', color: '#3A4F72', fontSize: 12, minHeight: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  Solte aqui
                </div>
              )}
            </div>
          );
        })}

        {/* Coluna Ganhos */}
        <div className="crm-col" onDragOver={e => { e.preventDefault(); setDragOver('ganho'); }}
          onDragLeave={() => setDragOver(null)}
          onDrop={() => onDrop('ganho')}
          style={{ minWidth: 200, flex: '0 0 200px', background: dragOver === 'ganho' ? 'rgba(74,222,128,.08)' : 'rgba(25,36,58,.6)', border: `1px solid ${dragOver === 'ganho' ? 'rgba(74,222,128,.4)' : '#2A3652'}`, borderTop: '3px solid #4ADE80', borderRadius: 14, padding: 14, transition: 'all .15s' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: '#4ADE80', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>✓ Ganho</p>
          <p style={{ fontSize: 12, color: '#64748B', marginBottom: 8 }}>{metricas.ganhos} fechamento{metricas.ganhos !== 1 ? 's' : ''}</p>
          {Number(metricas.ticket_medio) > 0 && <p style={{ fontSize: 11, color: '#64748B', marginBottom: 10 }}>Ticket médio: {moeda(metricas.ticket_medio)}</p>}
          {ganhos.slice(0, 5).map(l => (
            <div key={l.id} onClick={() => setDetalhe(l)} style={{ background: 'rgba(74,222,128,.08)', border: '1px solid rgba(74,222,128,.2)', borderRadius: 8, padding: '6px 10px', marginBottom: 6, fontSize: 12, color: '#4ADE80', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer' }}>
              {l.empresa}
            </div>
          ))}
        </div>

        {/* Coluna Perdidos */}
        <div className="crm-col" onDragOver={e => { e.preventDefault(); setDragOver('perdido'); }}
          onDragLeave={() => setDragOver(null)}
          onDrop={() => onDrop('perdido')}
          style={{ minWidth: 200, flex: '0 0 200px', background: dragOver === 'perdido' ? 'rgba(248,113,113,.06)' : 'rgba(25,36,58,.6)', border: `1px solid ${dragOver === 'perdido' ? 'rgba(248,113,113,.3)' : '#2A3652'}`, borderTop: '3px solid #F87171', borderRadius: 14, padding: 14, transition: 'all .15s' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: '#F87171', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>✗ Perdido</p>
          <p style={{ fontSize: 12, color: '#64748B', marginBottom: 8 }}>{metricas.perdidos} lead{metricas.perdidos !== 1 ? 's' : ''}</p>
          {perdidos.slice(0, 5).map(l => (
            <div key={l.id} onClick={() => setDetalhe(l)} style={{ background: 'rgba(248,113,113,.06)', border: '1px solid rgba(248,113,113,.15)', borderRadius: 8, padding: '6px 10px', marginBottom: 6, fontSize: 12, color: '#F87171', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer' }}>
              {l.empresa}
            </div>
          ))}
        </div>
      </div>

      {/* Modais */}
      <Modal open={modalNovo} onClose={() => setModalNovo(false)} title="Novo Lead" size="lg">
        <FormLead usuarios={usuarios} onSalvar={criarLead} onFechar={() => setModalNovo(false)} />
      </Modal>

      <Modal open={!!editando} onClose={() => setEditando(null)} title={`Editar: ${editando?.empresa}`} size="lg">
        {editando && <FormLead inicial={editando} usuarios={usuarios} onSalvar={editarLead} onFechar={() => setEditando(null)} />}
      </Modal>

      <Modal open={!!detalhe && !editando} onClose={() => setDetalhe(null)} title={detalhe?.empresa} size="lg">
        {detalhe && (
          <DetalheLead
            lead={detalhe}
            usuarios={usuarios}
            onMover={moverLead}
            onEditar={() => { setEditando(detalhe); setDetalhe(null); }}
            onExcluir={() => excluirLead(detalhe.id)}
            onFechar={() => setDetalhe(null)}
          />
        )}
      </Modal>
    </div>
  );
}
